<template>
  <div class="register" :style="{minHeight:bool?'120vh':'100vh'}">
         <div class="header">
            <div class="left">
              <van-icon @click="onBack" name="arrow-left" />
                <!-- <div class="back" @click="onBack">
                     
                </div> -->
               
                <!-- <div class="close" @click="close">关闭</div> -->
            </div>
            <div class="center text-overflow_1-xzh"></div>
            <!-- <div class="right" @click="refresh"></div> -->
        </div>
        <div class='img'>
            <img :src="url" alt="">
        </div>
        
  </div>
</template>
<script>
import {isWechatBrowser,isIos} from "@/utils/index.js"
export default {

  components: {
  
  },
  data() {
    return {
      url:''

    }
  },

  created() {
     this.url=this.$route.query.code
  },
  mounted() {
    
  },
  computed:{
    bool(){
      return isWechatBrowser() && isIos()
    }
  },
  methods: {
    onBack: function () {
      this.$router.go(-1)
    },
    // 刷新
    refresh: function () {
        location.reload()
    },

    
  },
}
</script>
<style lang="less" scoped>
.register{
     //min-height: 120vh;

    background: url('../../assets/register/bgtse.png') no-repeat ;
    background-size: 7.5rem ;
   
    
  .header {
  position: relative;
  width: 100%;
  height: 0.88rem;
  color:#fff;
  line-height: 0.88rem;
  font-size: 0.34rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 0.01rem solid transparent;
    .left{
        display: flex;align-items: center; justify-content: center;
        position: absolute;
        bottom: 0;
        left: .3rem;
        height: 0.88rem;
        .back{
              height: .32rem;
                width: 0.18rem;
               
        }
        .close{
           margin-left: 0.16rem;
            font-size:.3rem;
            font-weight:500;
            color:rgba(47,47,47,1);  
        }
    }
    .right{
        width: 0.32rem;
        height: 0.32rem;
        background: url('../../assets/icon-refresh.png') no-repeat;
        background-size: 100% 100%;
        position: absolute;
        right: 0.3rem;
        top: 0.29rem;
    }
    .center{
        width: 5rem;
        text-align: center;
    }
 }  
 .img{
   //margin: 7.5rem auto 0;
   margin-top: 7.5rem;
   display: flex;
   justify-content: center;
   
   img{
     width: 1.68rem;
     height: 1.68rem;
     
     
   }
 }
}
</style>






// WEBPACK FOOTER //
// src/pages/user/registered.vue